import actionTypes from '../action-types'

const initialState = {
  ids: [],
  count: 0,
  isFetching: false,
  page: 1,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ids: action.payload.result,
        count: action.payload.count,
        page: action.payload.page,
      }

    case actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_FAILURE:
      return {
        ...state,
        isFetching: false,
      }

    default:
      return state
  }
}
